<template>
  <v-card class="pa-4 d-flex flex-column" height="100%" elevation="0">
    <v-card-title class="text-h6 font-weight-light pl-0">
      {{ $t("profile.jobInformationCard.jobInformation") }}
    </v-card-title>
    <v-form
      class="mb-0 flex-grow-1 d-flex flex-column"
      v-model="validForm"
      :disabled="!valid"
    >
      <v-row class="flex-grow-1">
        <v-col cols="12" lg="7">
          <v-text-field
            v-model="jobTitle"
            :label="$t('profile.jobInformationCard.jobTitle')"
            outlined
          ></v-text-field>
          <v-text-field
            v-model="entryDate"
            :label="$t('profile.jobInformationCard.entryDate')"
            placeholder=""
            outlined
            type="date"
          ></v-text-field>
          <v-select
            v-model="department"
            :label="$t('profile.jobInformationCard.department')"
            :items="departments"
            outlined
            v-if="this.$store.getters.getUser.role == 'superuser'"
          ></v-select>
        </v-col>
        <v-col cols="12" lg="5" class="d-flex justify-end align-end">
          <v-btn
            class="text-case-normal px-6 my-lg-3 edit-button"
            :disabled="
              !valid ||
              !validForm ||
              this.$store.getters.getUser.role !== 'superuser'
            "
            @click="updateJob"
          >
            {{ $t("profile.jobInformationCard.saveChanges") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import * as Sentry from "@sentry/vue";
import user from "@/api/user.js";
import moment from "moment";
import { getAllDepartmentOptions } from "@/constants/departments.js";
export default {
  name: "JobInformationCard",
  props: ["valid"],
  data() {
    return {
      jobTitle: "",
      entryDate: "",
      department: "",
      departments: [],
      validForm: true,
    };
  },
  methods: {
    async updateJob() {
      const data = {
        email: this.$store.getters.getUser.email,
        entry_date: this.entryDate,
        job_title: this.jobTitle,
        department: this.department,
        name: this.$store.getters.getUser.name,
        phone: this.$store.getters.getUser.phone,
        role: this.$store.getters.getUser.role,
      };

      this.validForm = false;

      try {
        const response = await user.updateUser(data);
        if (response.code === 200) {
          let dataAlert = {
            message: this.$t("profile.jobInformationCard.jobUpdated"),
            status: "success",
          };
          this.$emit("alert", dataAlert);
          await this.$store.dispatch("authenticateAndLoadUser", false);
        } else {
          let dataAlert = {
            message: this.$t("profile.jobInformationCard.updateFailed"),
            status: "error",
          };
          this.$emit("alert", dataAlert);
        }
        await this.$store.dispatch("updateJob", data);
      } catch (error) {
        Sentry.captureException(error);
        let dataAlert = {
          message: this.$t("profile.jobInformationCard.updateFailed"),
          status: "error",
        };
        this.$emit("alert", dataAlert);
      } finally {
        this.validForm = true;
      }
    },
    setSelectOptions() {
      this.departments = getAllDepartmentOptions(
        this.$t.bind(this),
        "profile.jobInformationCard",
      );
    },
    syncFromStore() {
      const user = this.$store.getters.getUser;
      if (!user || !user.email) {
        return;
      }
      this.entryDate = user.entry_date
        ? moment(user.entry_date).format("MM / DD / YYYY")
        : "";
      this.jobTitle = user.job_title;
      this.department = user.department;
      this.setSelectOptions();
    },
  },
  mounted() {
    this.syncFromStore();
  },
  activated() {
    this.syncFromStore();
  },
  watch: {
    "$i18n.locale": function () {
      this.setSelectOptions();
    },
  },
};
</script>
